<script setup lang="ts">
import { onMounted } from "vue";
import { useHomepageStore } from "@/stores/homepageStore";
import BookingComponent from "@/components/BookingComponent/BookingComponent.vue";
import CustomButton from "@/components/Button/Button.vue";
import {useRouter} from "vue-router";


const homepageStore = useHomepageStore();

const router = useRouter();

const scrollToContent = () => {
  const el = document.getElementById('scroll-to-home');
  if (el) {
    el.scrollIntoView({ behavior: 'smooth' });
  }
}

onMounted(() => {
  homepageStore.fetchHomepageData();
});


</script>

<template>
  <div
      class="landingImage"
      :style="{ backgroundImage: `linear-gradient(to bottom, rgba(16, 10, 53, 0.7), rgba(16, 10, 53, 0)), url(${homepageStore.heroImageUrl})` }"
  >
    <div class="container hero-container items-center flex flex-col gap-6 h-full justify-center">
      <div class="responsive-title-2 sm:responsive-title-1 mt-12 mb-6 ml-3 text-center font-thin">
        <span>Authentic Greek Yachting Voyage</span>
      </div>
      <div class="flex justify-center w-full mb-4">
<!--        <BookingComponent />-->
        <CustomButton
            type="red"
            size="medium"
            class="py-5 px-6"
            @click="router.push('/yachts')"
        >
          Browse Yachts
        </CustomButton>
      </div>
    </div>
    <div
        class="hidden mt-6 mb-2 sm:mt-10 sm:flex flex-col gap-2 items-center text-white responsive-body-large font-bold cursor-pointer"
        @click="scrollToContent"
    >
      EXPLORE MORE
      <img src="@/assets/icons/arrow_down.png" alt="Explore">
    </div>
  </div>




</template>

<style scoped>
.landingImage {
  background-size: cover;
  background-position: center;
  object-fit: contain;
  background-attachment: fixed;
  height: 100vh;
  max-height: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  gap: 40px;
}



@media (max-width: 768px) {
  .landingImage {
    max-height: none;
    background-position: center;
  }
}

</style>
